module.exports = __webpack_public_path__ + "img/favicon_le-lys-bleu-editions.9dc7db70.png";